const PageNotFound = () => {
  return (
    <main>
      <section className="d-flex align-items-center">
        <div className="container vh-100">
          <div className="row h-100 text-center align-items-center">
            <h1>Page Not Found</h1>
          </div>
        </div>
      </section>
    </main>
  );
};

export default PageNotFound;
